(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nmt-fixed-scene"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nmt-fixed-scene')){
customElements.define('nmt-fixed-scene',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;
  this.abort=new AbortController();const options={signal:this.abort.signal};
  this.phone=this.querySelector('.nmt-fixed-phone');this.clock=this.querySelector('.nmt-fixed-clock');
  this.button=this.querySelector('[data-pause]');this.vertical=false;
  this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.paused=this.motion.matches;this.details=this.closest('details');
  this.button.addEventListener('click',()=>{this.paused=!this.paused;this.start();},options);
  document.addEventListener('visibilitychange',()=>this.start(),options);
  this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.start();},options);
  if(this.details)this.details.addEventListener('toggle',()=>this.start(),options);
  this.start();
 }
 start(){this.button.setAttribute('aria-label',this.paused?'Play animation':'Pause animation');this.button.setAttribute('aria-pressed',String(this.paused));clearInterval(this.timer);if(this.paused||document.hidden||(this.details&&!this.details.open)){clearTimeout(this.displayTimer);this.displayTimer=null;return;}if(!this.displayTimer&&this.clock.classList.contains('portrait')!==this.vertical)this.displayTimer=setTimeout(()=>{this.clock.classList.toggle('portrait',this.vertical);this.displayTimer=null;},500);this.timer=setInterval(()=>this.advance(),5000);}
 advance(){this.vertical=!this.vertical;this.phone.classList.toggle('vertical',this.vertical);clearTimeout(this.displayTimer);if(this.motion.matches){this.clock.classList.toggle('portrait',this.vertical);this.displayTimer=null;}else this.displayTimer=setTimeout(()=>{this.clock.classList.toggle('portrait',this.vertical);this.displayTimer=null;},1200);}
 disconnectedCallback(){clearInterval(this.timer);clearTimeout(this.displayTimer);this.abort?.abort();this.abort=null;}
});}
  } catch(e) { console.error(e); }
})();

})();
